<template>
  <div>
    <!-- 避免页面其他元素的干扰-->
    <div
      v-if="mStatus == 'down'"
      class="float-container-moveBg"
      @mousemove="mousemove"
      @mouseup="mouseupW"
    ></div>
    <div
      class="float-container"
      id="PgFloatContainer"
      @mousedown="mousedown"
      @mouseup="mouseup"
      :style="{ left: curLocation[0] + 'px', top: curLocation[1] + 'px' }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, onBeforeUnmount, getCurrentInstance } from 'vue'

const emit = defineEmits(['mouseup', 'mousedown', 'oClick', 'adsorptionPosition'])

// 当前组件，可扩展，目前只针对浮动区域 在window窗口上的吸附
const props = defineProps({
  // 是否需要贴边 吸附 会被吸附在四边
  adsorption: {
    type: Boolean,
    default: false,
  },
  // 移动方向 all：所有方向 transverse：横向 direction：纵向
  moveDirection: {
    type: String,
    default: 'direction',
  },
  // 初始位置，设置 [left, top] 如果没有给初始位置，会根据window计算一个
  defaultLocation: {
    type: Array,
    default: () => [200, 0],
  },
})

// 获取当前实例
const { proxy } = getCurrentInstance()

// adsorption：true 记录当前吸附位置 top right bottom left 确定箭头的位置 默认right
const curPosition = ref('right')

// 指向container 当前位置, 默认为defaultLocation
const curLocation = ref(props.defaultLocation)

// ---判断点击事件与拖动事件----
// 鼠标松开，当前鼠标相对屏幕 [clientX, clientY]
const muLocationClient = ref([0, 0])

// 鼠标按下，当前鼠标相对屏幕 [clientX, clientY]
const mdLocationClient = ref([0, 0])
// -------------------------------------

// 鼠标按下，鼠标相对于container的[offsetX, offsetY]
const mdLocationOffset = ref([0, 0])

// 鼠标当前状态 down: 按下 up:弹起
const mStatus = ref('')

// document.documentElement 大小 作为container移动的边界, 后期可扩展为指定区域，这个时候需要传入区域的id
const dArea = ref([]) //[]

// container的大小
const cArea = ref([]) //[]

// container dom元素
const container = computed(() => {
  return document.querySelector('#PgFloatContainer') ?? null
})

// container的mouseup事件
const mouseup = (evt) => {
  emit('mouseup')
  mStatus.value = 'up'
  muLocationClient.value = [evt.clientX, evt.clientY]
  // 判断相对位置， 如果鼠标按下与鼠标松开时相对位置在0-7之间，可出发clickFn事件，否则就是拖动事件
  const d = Math.sqrt(
    (mdLocationClient.value[0] - muLocationClient.value[0]) *
      (mdLocationClient.value[0] - muLocationClient.value[0]) +
      (mdLocationClient.value[1] - muLocationClient.value[1]) *
        (mdLocationClient.value[1] - muLocationClient.value[1])
  )
  if (d === 0 || d < 7) {
    emit('oClick') // 执行了点击事件
  } else {
    // 执行 拖动事件
    getCurLocation(evt)
  }
}

// window的mouseupW事件：拖动时，鼠标可能会离开 container 因此还需要监听window的拖动事件
const mouseupW = () => {
  mStatus.value = 'up'
  container.value.style.cursor = 'default' // 体验优化，修改一下鼠标样式为箭头
  emit('mouseup')
}

// container的mousedown事件
const mousedown = (evt) => {
  mStatus.value = 'down' // 鼠标动作
  mdLocationClient.value = [evt.clientX, evt.clientY] // 鼠标相对window可视区域的 [clientX, clientY]

  container.value.style.cursor = 'pointer' // 体验优化，修改一下鼠标样式为手

  // 鼠标按下时，相对container的位置
  mdLocationOffset.value[0] = evt.offsetX
  mdLocationOffset.value[1] = evt.offsetY

  emit('mousedown')
}

const mousemove = (evt) => {
  console.log('mStatus', mStatus.value)
  if (mStatus.value != 'down') return
  console.log('111111111111111111111')
  let tempArr = []
  var newT = evt.clientY - mdLocationOffset.value[1]
  if (newT <= 0) {
    tempArr[1] = 0
  } else if (newT > dArea.value[1] - cArea.value[1]) {
    tempArr[1] = dArea.value[1] - cArea.value[1]
  } else {
    tempArr[1] = newT
  }

  var newL = evt.clientX - mdLocationOffset.value[0]
  if (newL <= 0) {
    tempArr[0] = 0
  } else if (newL > dArea.value[0] - cArea.value[0]) {
    tempArr[0] = dArea.value[0] - cArea.value[0]
  } else {
    tempArr[0] = newL
  }

  console.log('mousemove')
  console.log('curLocation', curLocation.value)
  console.log('mStatus', mStatus.value)

  switch (props.moveDirection) {
    case 'all':
      curLocation.value[0] = tempArr[0]
      curLocation.value[1] = tempArr[1]
      break // 如果是万向， 就直接返回当前的位置
    case 'transverse':
      curLocation.value[0] = tempArr[0]
      break // 横向
    case 'direction':
      curLocation.value[1] = tempArr[1]
      break // 纵向
    default:
      curLocation.value[0] = props.defaultLocation[0]
      curLocation.value[1] = props.defaultLocation[1]
  }

  proxy.$forceUpdate()
}

const getCurLocation = (evt) => {
  if (props.adsorption) {
    // 找到当前位置，上右下左距离最近的距离
    const tempL = [
      evt.clientY,
      dArea.value[0] - evt.clientX,
      dArea.value[1] - evt.clientY,
      evt.clientX,
    ]
    let minLIndex = 0,
      minL = tempL[0]
    tempL.reduce((prev, next, index) => {
      if (next <= minL) {
        minL = next
        minLIndex = index
      }
    })
    switch (minLIndex) {
      case 0:
        curPosition.value = 'top'
        curLocation.value[0] = evt.clientX
        curLocation.value[1] = 0
        break // 距离上最近  x不变 y=0
      case 1:
        curPosition.value = 'rigth'
        curLocation.value[0] = dArea.value[0] - cArea.value[0]
        curLocation.value[1] = evt.clientY
        break // 距离右最近 x=最大距离 y不变
      case 2:
        curPosition.value = 'bottom'
        curLocation.value[0] = dArea.value[0] - cArea.value[0]
        curLocation.value[1] = dArea.value[1] - cArea.value[1]
        break // 距离下最近 x不变 y=最大距离
      case 3:
        curPosition.value = 'left'
        curLocation.value[0] = dArea.value[0] - cArea.value[0]
        curLocation.value[1] = evt.clientY
        break // 距离左边最近 x=0 y不变
      default:
        curLocation.value[0] = props.defaultLocation[0]
        curLocation.value[1] = props.defaultLocation[1]
    }

    emit('adsorptionPosition', curPosition.value)

    console.log('mouseup')
    console.log('curLocation', curLocation.value)

    proxy.$forceUpdate()
  }
}

// 组件都加载好后执行
onMounted(() => {
  // document.documentElement 大小
  dArea.value[0] = document.documentElement.clientWidth
  dArea.value[1] = document.documentElement.clientHeight

  // container的大小
  cArea.value[0] = document.querySelector('#PgFloatContainer').clientWidth
  cArea.value[1] = document.querySelector('#PgFloatContainer').clientHeight

  // 为 document 注册  mousemove,  mouseup
  //   window.addEventListener('mousemove', mousemove)
  //   window.addEventListener('mouseup', mouseupW)
})

// 组件将要卸载前执行
onBeforeUnmount(() => {
  // 为 document 卸载  mousemove,  mouseup
  //   window.removeEventListener('mousemove', mousemove)
  //   window.removeEventListener('mouseup', mouseupW)
})
</script>
<style lang="scss">
@import '../style/float-container.scss';
</style>
